<template>
  <event-card :img-src="event.mainImage" :title="event.name" :subtitle="event.descriptionShort">
    <div class="event-tile__media">
      <ul class="tags-container flex-column px-0">
        <li class="tag" role="region" aria-label="Nazwa partnera">
          <v-icon class="mr-4 lighten-2">mdi-storefront</v-icon>
          <div v-if="!event.shared">
            <p class="sr-only">Nazwa partnera</p>

            <router-link v-if="event.partner" :to="{ name: 'partnerDetails', params: { id: event.partner.id } }">
              {{ event.partner.name }}
            </router-link>
          </div>

          <div v-else>
            <p>Usługa dostępna u wielu partnerów</p>
          </div>
        </li>

        <li v-if="!event.shared" class="tag" role="region" aria-label="Miejsce usługi">
          <v-icon class="mr-4 lighten-2">mdi-map-marker-outline</v-icon>

          <p class="sr-only">Miejsce usługi</p>

          <p>{{ place }}</p>
        </li>

        <li v-if="event.start && event.end" class="tag" role="region" aria-label="Data usługi">
          <v-icon class="mr-4 lighten-2">mdi-calendar</v-icon>

          <p class="sr-only">Data usługi</p>

          <p>{{ event.start | dateFilter }} - {{ event.end | dateFilter }}</p>
        </li>

        <li class="tag" role="region" aria-label="Typ zniżki">
          <v-icon class="mr-4 lighten-2">{{ event.type | benefitIconType }}</v-icon>

          <p class="sr-only">Typ zniżki</p>

          <p>
            <b>
              {{ event.type | benefitType }}:
              <span>{{ event | benefitValue }}</span>
            </b>
          </p>
        </li>

        <li role="region" aria-label="Grupy" class="tag">
          <v-icon class="mr-4 lighten-2">mdi-account-group</v-icon>

          <p class="sr-only">Grupy</p>

          <p>
            <b>
              Grupy:
            </b>

            <span>{{ groups }}</span>
          </p>
        </li>

        <li v-if="event.pointCost && event.pointContainer.name" role="region" class="tag">
          <v-icon class="mr-4 lighten-2">mdi-star-circle</v-icon>

          <p>
            <b>
              Wymagana liczba punktów:
            </b>

            <br />

            <span>{{ event.pointCost }} pkt. - {{ event.pointContainer.name }}</span>
          </p>
        </li>
      </ul>

      <v-btn large outlined elevation="0" color="primary" @click="goToDetails">Zobacz usługę</v-btn>
    </div>
  </event-card>
</template>

<script>
import {
  address,
  benefitIconType,
  benefitType,
  benefitValue,
  dateFilter,
  DisplayBenefitType,
  PublicSettings
} from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import EventCard from '@/components/base/EventCard';

// @vuese
// Karta wydarzenia
// @group Cards
export default {
  components: { EventCard },
  filters: { address, benefitIconType, benefitType, benefitValue, dateFilter, DisplayBenefitType },
  props: {
    // Obiekt wydarzenia / usługi
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      noGroupSetting: state => state.settings[PublicSettings.NO_GROUP_SELECTED_NAME].value
    }),
    place() {
      if (this.event.place) {
        return address(this.event.place);
      }
      return 'Usługa dostępna we wszystkich obiektach';
    },
    groups() {
      if (!this.event.groups.length) {
        return this.noGroupSetting;
      }
      const firstThree = this.event.groups.map(group => group.name).slice(0, 3);
      const left = this.event.groups.length - 3;
      return `${firstThree.join(', ')} ${left > 0 ? 'oraz ' + left + ' więcej' : ''}`;
    }
  },
  methods: {
    // @vuese
    // Pokaż szczegóły
    goToDetails() {
      this.$router.push({
        name: 'eventDetails',
        params: { id: this.event.id }
      });
    }
  }
};
</script>
